module.exports = __webpack_public_path__ + "img/SSWS_Steel_sword.c42917ad.png";